import axios from 'axios';
import React, { useContext, useEffect, useRef, useState } from 'react';
import { initFacebookPixel, trackEvent } from '../../pixel'; 
import { useParams } from 'react-router-dom';
import { config } from '../../config';
import { PixelContext } from '../Context/PixelContext';

const apiUrl = config.apiUrl;

const Congratulations = () => {
  const [congratulation, setCongratulation] = useState({});
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(true);
  const { slug } = useParams();
  const pixelInitialized = useRef(false);

  const { pixel } = useContext(PixelContext);
  const pixelId = pixel?.pixel_id || null;

    // Get user data from localStorage
  const name = localStorage.getItem('name') || '';
  const email = localStorage.getItem('email') || '';
  const phone = localStorage.getItem('whatsapp') || '';
  
  useEffect(() => {
    if (pixelId) {
      initFacebookPixel(pixelId);
    }
  }, [pixelId]);

  const trackDashboardClick = () => {
    trackEvent('DashboardRegistration', {
      content_name: 'Dashboard Registration',
      content_category: 'button_click',
      content_ids: [slug],
      email: email,
      phone: phone,
      name: name,
      external_id: phone
    });
    window.location.href = '/register';
  };

  useEffect(() => {
    const fetchData = async() => {
      try {
        const response = await axios.get(`${apiUrl}/congratulations/${slug}`);
        setCongratulation(response.data.congratulation);
      } catch (error) {
        setError("Error fetching data:", error);
      } finally {
        setLoading(false); 
      }
    }
    fetchData();
  }, [slug]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 to-green-50">
        <div className="flex flex-col items-center">
          <div className="w-16 h-16 border-4 border-green-500 border-t-transparent rounded-full animate-spin mb-4"></div>
          <p className="text-gray-600">আপনার সেলিব্রেশন লোড হচ্ছে...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-red-50 to-pink-50 p-5">
        <div className="bg-white rounded-xl shadow-lg p-8 w-full max-w-2xl mx-4 text-center">
          <div className="text-red-500 mb-4">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-16 w-16 mx-auto" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          </div>
          <h1 className="text-2xl font-bold text-gray-800 mb-2">ওহো!</h1>
          <p className="text-gray-600 mb-6">{error}</p>
          <button 
            onClick={() => window.location.reload()}
            className="px-6 py-2 bg-red-500 hover:bg-red-600 text-white rounded-lg transition duration-300"
          >
            আবার চেষ্টা করুন
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 to-green-50 p-4">
      <div className="relative w-full max-w-4xl mx-auto">
        {/* Confetti animation elements */}
        {[...Array(50)].map((_, i) => (
          <div 
            key={i}
            className={`absolute w-3 h-3 rounded-full bg-${['yellow', 'pink', 'blue', 'green', 'purple'][i%5]}-400 opacity-80`}
            style={{
              top: `${Math.random() * 100}%`,
              left: `${Math.random() * 100}%`,
              animation: `confetti-fall ${3 + Math.random() * 4}s linear infinite`,
              animationDelay: `${Math.random() * 2}s`,
              zIndex: 0
            }}
          ></div>
        ))}
        
        <div className="bg-white rounded-xl shadow-2xl overflow-hidden w-full transform transition-all hover:scale-[1.01] duration-300 relative z-10">
          {/* Ribbon */}
          <div className="absolute top-0 right-0 w-40 h-40 overflow-hidden">
            <div className="absolute top-0 right-0 w-72 h-10 bg-green-500 transform rotate-45 translate-y-6 translate-x-10 flex items-center justify-center shadow-md">
              <span className="text-white text-sm font-bold">সফলতা!</span>
            </div>
          </div>
          
          <div className="p-8 md:p-10 text-center">
            {/* Animated checkmark */}
            <div className="mb-8 flex justify-center">
              <div className="relative">
                <svg 
                  className="w-24 h-24 text-green-500 animate-checkmark" 
                  xmlns="http://www.w3.org/2000/svg" 
                  viewBox="0 0 24 24" 
                  fill="none" 
                  stroke="currentColor" 
                  strokeWidth="2"
                >
                  <path 
                    className="animate-checkmark-path"
                    strokeLinecap="round" 
                    strokeLinejoin="round" 
                    d="M5 13l4 4L19 7" 
                  />
                </svg>
                <div className="absolute inset-0 rounded-full bg-green-100 opacity-30 animate-ping"></div>
              </div>
            </div>
            
            <h1 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4">
              <span className="bg-clip-text text-transparent bg-gradient-to-r from-green-600 to-blue-600">
                {congratulation.headline || 'অভিনন্দন!'}
              </span>
            </h1>
            
            <p className="text-lg md:text-xl text-gray-600 mb-6">
              {congratulation.subHeadline || 'আপনার মেম্বারশিপ সফলভাবে সক্রিয় হয়েছে!'}
            </p>
            
            <div className="my-8 px-6 py-4 bg-blue-50 rounded-xl border border-blue-100 shadow-inner mx-auto max-w-2xl">
              <p className="text-gray-700 md:text-lg">
                {congratulation.paragraph || 'আপনার স্বাগতম ইমেইল এবং অ্যাক্সেস ডিটেইলস প্রস্তুত হচ্ছে। কিছুক্ষণের মধ্যে আপনি একটি ইমেইল পাবেন যাতে আপনার লগইন তথ্য এবং সম্পূর্ণ মেম্বারশিপ সুবিধা সম্পর্কে বিস্তারিত থাকবে।'}
              </p>
            </div>
            
            
            {/* Progress animation */}
            <div className="relative pt-1 mb-8 max-w-2xl mx-auto">
              <div className="flex mb-2 items-center justify-between">
                <div>
                  <span className="text-sm font-semibold inline-block py-1 px-3 uppercase rounded-full text-green-600 bg-green-200">
                    প্রসেসিং
                  </span>
                </div>
                <div className="text-right">
                  <span className="text-sm font-semibold inline-block text-green-600">
                    ৯০% সম্পূর্ণ
                  </span>
                </div>
              </div>
              <div className="overflow-hidden h-3 mb-4 text-xs flex rounded-full bg-green-200 shadow-inner">
                <div 
                  className="shadow-none flex flex-col text-center whitespace-nowrap text-white justify-center bg-gradient-to-r from-green-500 to-blue-500 animate-progress"
                  style={{ width: '100%' }}
                ></div>
              </div>
            </div>
            
            <div className="mt-8 space-y-4">
              <button 
                onClick={trackDashboardClick}
                className="px-10 py-4 bg-gradient-to-r from-green-600 to-blue-600 hover:from-green-700 hover:to-blue-700 text-white font-semibold rounded-full shadow-lg transition-all duration-300 transform hover:scale-105 w-full max-w-xs mx-auto block"
              >
                ড্যাশবোর্ডে রেজিস্টার করুন
              </button>
              
              <p className="text-sm text-gray-500">
                {congratulation.contactInfoText || 'কোনো সাহায্য প্রয়োজন? আমাদের সাপোর্ট টিমে যোগাযোগ করুন: support@example.com'}
              </p>
            </div>
          </div>
        </div>
      </div>
      
      <style jsx>{`
        @keyframes confetti-fall {
          0% { transform: translateY(-100vh) rotate(0deg); opacity: 1; }
          100% { transform: translateY(100vh) rotate(360deg); opacity: 0; }
        }
        
        @keyframes checkmark-path {
          0% { stroke-dashoffset: 100; }
          100% { stroke-dashoffset: 0; }
        }
        
        .animate-checkmark-path {
          stroke-dasharray: 100;
          stroke-dashoffset: 0;
          animation: checkmark-path 1s ease-out forwards;
        }
        
        @keyframes progress {
          0% { width: 0%; }
          100% { width: 90%; }
        }
        
        .animate-progress {
          animation: progress 2s ease-out forwards;
        }
      `}</style>
    </div>
  );
};

export default Congratulations;